export default "__VITE_ASSET__BQ$phFZI__"